// Pure/isomorphic half of the CTA variant engine — split out of lib/ctaVariants.ts so
// client components (QuickConsultClient etc.) can import pickVariantIndex/CtaVariant
// without pulling in lib/db.ts (mysql2), which isn't bundlable client-side.
export type CtaVariant = { id: number; key: string; label: string; copyText: string };

// Deterministic bucketing — same seed always maps to the same index, so a visitor sees
// the same CTA copy across re-renders/navigation instead of flickering between variants.
// Plain string hash (not crypto-grade, doesn't need to be) — stable across Node/browser.
export function pickVariantIndex(seed: string, count: number): number {
  if (count <= 0) return 0;
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h * 31 + seed.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % count;
}
